/* English labels for the third-party offer widget. Product data and prices are untouched. */
(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
  const translate = value => value
    .replace(/Mehr Sparen, Indem Sie Mehr Kaufen!/gi, 'Buy more, save more!')
    .replace(/Sie Sparen/gi, 'You save')
    .replace(/BESTER PREIS/g, 'BEST VALUE')
    .replace(/\b(\d+)\s+Stück\b/g, (_, count) => `${count} ${Number(count) === 1 ? 'item' : 'items'}`);
  let queued = false;
  const update = () => {
    queued = false;
    document.querySelectorAll('.kaching-bundles').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea')) continue;
        const next = translate(node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
      root.querySelectorAll('[aria-label],[title]').forEach(element => {
        for (const name of ['aria-label', 'title']) {
          const current = element.getAttribute(name);
          if (current) {
            const next = translate(current);
            if (next !== current) element.setAttribute(name, next);
          }
        }
      });
    });
  };
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  };
  const start = () => {
    new MutationObserver(schedule).observe(document.body, { childList: true, characterData: true, subtree: true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
